import { render, staticRenderFns } from "./EventReport.vue?vue&type=template&id=2b801fd2&scoped=true"
import script from "./EventReport.vue?vue&type=script&lang=js"
export * from "./EventReport.vue?vue&type=script&lang=js"
import style0 from "./EventReport.vue?vue&type=style&index=0&id=2b801fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b801fd2",
  null
  
)

export default component.exports